import React from 'react';
import useSafeState from '../../../../useSafeState' 
import * as api from '../../../../Auth/auth'
import TableCard from '../../../../components/Table/TableCard'


export function VaccsTableData() {

  const [value, setValue] = useSafeState({});
  const [data, setData] = React.useState(React.useMemo(() => []));
  const [loading, setLoading] = React.useState(false);
    
    React.useEffect( () => {
      getData()
  }, [])

  async function getData() {
    
    setLoading(true)
    const response = await api.vaccListFetch();
    const d = handleData(response)
    setData( d )
    setLoading(false)
           // NO MEMORY LEAK
    setValue({ key: 'value' });
    }

    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {    'col1': response[i].id,
                                            'col2': response[i].vacc_date,
                                            'col3': response[i].vacc_type,
                                            'col4': response[i].owner,
                                            
                                        },
                                  );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
          
        {
          header: 'ID',
          accessorKey: 'col1',
          cell: info => info.getValue(),
          },  
          {
            header: 'Date',
            accessorKey: 'col2',
            cell: info => info.getValue(),
            },  
          {
              header: 'Vaccine',
              accessorKey: 'col3',
              cell: info => info.getValue(),
            },
      ],
      []
      )

return (

<div>
      { loading && <span> Please wait ... fetching data </span>}
      <TableCard columns={columns} data={data} />
</div>
);
}